<template>
  <div class="document banner">
    <font-awesome-icon :icon="['fas', 'question-circle']" class="banner-info-icon fa-2x"/>
    <span class="banner-text-section banner-header">
      <div class="banner-title">Calculate Worksheet</div>
      <span>CEP Calculate Worksheet</span>
    </span>
    <div class="banner-separator"></div>
    <es-loader v-if="loadingSummary" style="margin: auto"/>
    <span class="banner-text-section" v-else-if="hasAccess">
      This worksheet defines the values that will be submitted on the Election: Submission tab.
      Please ensure you update the Participation Decision column in the Sites section and update
      the Base Year Decision in the Elections Participation Summary section below before clicking
      the Save Elections Calculations button.
    </span>
    <template v-else>
      <font-awesome-icon
        :icon="['fas', 'exclamation-triangle']"
        class="banner-info-icon banner-info-icon-no-access fa-2x"/>
      <span class="banner-text-section">
        Elections Data Not Available. You are trying to access this page before the Population
        Submission Due Date or the Population Data has not been submitted/accepted.
      </span>
    </template>
    <template v-if="hasRefresh || cepSummary.recalculateStatus === 'I'">
      <div class="banner-separator"></div>
      <button
        class="button is-primary banner-refresh-button"
        :disabled="loading"
        @click="refresh">
          {{ this.cepSummary.recalculateStatus === 'I' ? 'Refresh' : 'Load Election Data' }}
      </button>
    </template>
  </div>
</template>

<script>
import { faQuestionCircle, faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import EsLoader from '@/components/EsLoader.vue';

library.add(faQuestionCircle, faExclamationTriangle);

export default {
  components: {
    EsLoader,
  },
  methods: {
    refresh() {
      this.$emit('refresh');
    },
    setBusy(loading) {
      this.loading = loading;
    },
  },
  props: {
    hasRefresh: {
      type: Boolean,
      default: false,
    },
    hasAccess: {
      type: Boolean,
      default: false,
    },
    loadingSummary: {
      type: Boolean,
    },
    cepSummary: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
};
</script>

<style lang="sass" scoped>
  .banner
    margin-bottom: 1rem
    display: flex;
    align-items: center
    border: 1px solid #bbb
    border-left: 10px solid #7f7f7f
    padding: 0.75rem 1rem 0.75rem 1rem;
    color: #666;
    font-size: 12px;
    .banner-info-icon
      color: #bbb
      font-size: 36px
      &.banner-info-icon-no-access
        color: #ffc107
        padding-left: 15px
    .banner-text-section
      padding: 0 15px
      text-align: left
    .banner-separator
      border-left: 1px solid #dee2e6
      min-height: 100%
      align-self: stretch
    .banner-title
      font-size: 1.5rem
      color: #000
      line-height: 1.2
      margin-bottom: 0.2rem
      font-weight: 500
    .banner-header
      flex-shrink: 0
    .banner-refresh-button
      margin-left: 1rem
</style>
